import type {
  Flow_AbstractComponent,
  Flow_Diff,
  Flow_ComponentProps,
  Flow_ObjMap,
} from 'src/types/flow-to-typescript-codemod';
import * as React from 'react';

import EmojiPicker, {type Props as PickerProps} from './emoji-picker';

import css from './dialog.css';


export default function EmojiDialog({
  ...props
}: Flow_Diff<
  PickerProps,
  {
    classNames: Record<any, any>;
  }
>) {
  return (
    <div className={css.dialog}>
      <EmojiPicker {...props} classNames={css} />
    </div>
  );
}
